export default __webpack_public_path__ + "static/media/varify_no_img.eb81e270.png";